/**
 * A design-system `<Select>`'s `value` is `string | string[]` because the same
 * element also does multi-select. For a single select, take the one value.
 */
export const singleSelectValue = (
  value: string | string[] | null | undefined
): string => (Array.isArray(value) ? (value[0] ?? '') : (value ?? ''));
